import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { PassionIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';

import { IDrawer } from '../../../PublicationContent';
import './styled';
import {
  DataTypePassionIconContainer,
  DataTypePassionPillText,
  DataTypePassionPillWrapper,
} from './styled';

export const dataTypePassionContentModifier = (
  node: HTMLDivElement,
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>
) => {
  node.querySelectorAll('[data-type="passions"], [data-type="passion"]').forEach((passion) => {
    const slug = passion.getAttribute('data-slug');
    const name = passion.textContent;
    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(<DataTypePassionPill name={name || ''} />);

    template.firstChild.addEventListener('click', () => {
      setDrawer({ show: true, slug, type: 'passions' });
    });

    passion.replaceWith(template.firstChild);
  });
};

interface DataTypePassionPillProps {
  name: string;
}

export const DataTypePassionPill = ({ name }: DataTypePassionPillProps) => {
  return (
    <DataTypePassionPillWrapper>
      <DataTypePassionIconContainer>
        <PassionIcon width={16} height={16} fill={'var(--color-data-passion-foreground)'} />
      </DataTypePassionIconContainer>
      <DataTypePassionPillText>{name}</DataTypePassionPillText>
    </DataTypePassionPillWrapper>
  );
};
